import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Spinner } from "reactstrap";

import { ActivityReportData } from "./types";
import { pageLabel } from "./format";

/**
 * Pages are counted by name rather than URL: detail pages carry a record id, so
 * counting URLs reports every viewed record as a page of its own.
 */
const TopPages = ({
  data,
  loading,
}: {
  data: ActivityReportData | null;
  loading: boolean;
}) => {
  const rows = data?.pages || [];

  return (
    <Col xxl={6}>
      <Card className="card-height-100">
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Top pages</h4>
        </CardHeader>
        <CardBody>
          {loading ? (
            <div className="text-center py-5">
              <Spinner color="primary" size="sm" />
            </div>
          ) : rows.length === 0 ? (
            <div className="text-center text-ink-muted py-5">
              No page visits in this period.
            </div>
          ) : (
            <div className="table-responsive table-card">
              <table className="table align-middle table-borderless table-nowrap mb-0">
                <thead className="text-ink-muted table-light">
                  <tr>
                    <th scope="col" style={{ width: "50%" }}>
                      Page
                    </th>
                    <th scope="col">Visits</th>
                    <th scope="col">Users</th>
                    <th scope="col">Share of active users</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={`${row.pageName}-${index}`}>
                      <td
                        title={
                          row.pageName.startsWith("/")
                            ? row.pageName
                            : undefined
                        }
                      >
                        {row.pageUrl ? (
                          <Link to={row.pageUrl} className="fw-medium">
                            {pageLabel(row.pageName)}
                          </Link>
                        ) : (
                          <span className="fw-medium">
                            {pageLabel(row.pageName)}
                          </span>
                        )}
                      </td>
                      <td>{row.visits}</td>
                      <td>{row.users}</td>
                      <td>{row.percentOfActiveUsers}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopPages;
